import React, { Component } from "react";
import { Link } from "gatsby";
import styled from "styled-components";

class BannerImage extends Component {
  render() {
    let { data } = this.props;
    return (
      <Link to={data.path}>
        <Image src={this._getImgResource(data)} />
      </Link>
    );
  }

  _getImgResource = data => {
    if (window.screen.width === 1024) {
      return data.desktop;
    } else if (window.screen.width === 768) {
      return data.tablet;
    } else if (window.screen.width <= 600) {
      return data.mobile;
    }

    return data.desktop;
  };
}

const Image = styled.img`
  width: 100%;
  height: auto;
`;

export default BannerImage;
